export enum PaymentProperty {
  Amount = 1
}

export const PaymentPropertyType: Required<NonNullable<{ [key in PaymentProperty]: string }>> = {
  [PaymentProperty.Amount]: 'number'
}